import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CModel from "../../components/CModel/CModel";
// @mui
import {
  Card,
  Stack,
  Paper,
  Button,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Breadcrumbs,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Box,
} from "@mui/material";
// components
import Iconify from "../../components/iconify";
import ApiCall from "../../utils/apicall";
import { showSuccessToast, showErrorToast } from "../../utils/Toast";
import Scrollbar from "../../components/scrollbar";
import { UserListHead, UserListToolbar } from "../../sections/@dashboard/user";
import { useSelector } from "react-redux";
import {
  clearErrorMessage,
  deleteRole,
  getRoles,
} from "../../feature/roleSlice";
import { getPermission } from "../../feature/permissionsSlice";
import { HomeRounded } from "@mui/icons-material";
import { hasPermission, PERMISSIONS } from "../../utils/hasPermission";

import SmartTable from "../../components/SmartTable/SmartTable";
const TABLE_HEAD = [
  { id: "name", label: "Name", alignRight: false },
  { id: "permission", label: "Permission   ", alignRight: false },
  { id: "" },
];

export default function Roles(props) {
  const dispatch = useDispatch();
  //const open = false;
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errorMesage, setErrorMessage] = useState("");
  const [selectedRow, setSelectedRow] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [openUpdateModel, setOpenUpdateModel] = useState(false);
  const [dutiesRole, setDutiesRole] = useState(null);
  const [dutiesText, setDutiesText] = useState("");
  const [dutiesSaving, setDutiesSaving] = useState(false);
  const [dutiesAcks, setDutiesAcks] = useState([]);
  const openDuties = async (row) => {
    setDutiesRole(row); setDutiesText(row.duties_responsibilities || ""); setDutiesAcks([]);
    try { const r = await ApiCall.get(`/role/${row.id}/acknowledgments`); setDutiesAcks(r?.data?.data?.acknowledgments || []); } catch { setDutiesAcks([]); }
  };
  const saveDuties = async () => {
    if (!dutiesRole) return;
    setDutiesSaving(true);
    try {
      await ApiCall.put(`/role/${dutiesRole.id}/duties`, { duties: dutiesText });
      showSuccessToast("Duties & responsibilities saved. Holders of this position will be asked to re-sign.");
      setDutiesRole(null);
    } catch (err) {
      showErrorToast(err?.response?.data?.message || "Failed to save duties.");
    } finally { setDutiesSaving(false); }
  };
  const { roles, message } = useSelector((state) => state.roleSlice);
  const { permissions } = useSelector((state) => state.permissionSlice);
  const { loginUser } = useSelector((state) => state.userSlice);

  const { permissions: userPermissions } = loginUser.decodedToken;
  const canAddRole = hasPermission(userPermissions, PERMISSIONS.ADD_ROLE);
  const canEditRole = hasPermission(userPermissions, PERMISSIONS.EDIT_ROLE);
  const canDeleteRole = hasPermission(userPermissions, PERMISSIONS.DELETE_ROLE);
  const canViewRoleList = hasPermission(userPermissions, PERMISSIONS.VIEW_ROLE);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = roles.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  function applySortFilter(array, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);

    if (query) {
      return filter(
        roles,
        (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    }
    return stabilizedThis.map((el) => el[0]);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - roles.length) : 0;
  const filteredUsers = applySortFilter(roles, filterName);
  const isNotFound = !filteredUsers.length && !!filterName;

  const handleDelete = (id) => {
    dispatch(deleteRole(id));
  };
  const navigate = useNavigate();
  const handleOpenModel = () => {
    setOpenModel(!openModel);
  };
  useEffect(() => {
    if (message) {
      setErrorMessage(message);
    }
    dispatch(clearErrorMessage());
    return;
  }, [dispatch, message]);
  useEffect(() => {
    dispatch(getRoles());
    dispatch(getPermission());
  }, [dispatch, openModel, openUpdateModel]);
  return (
    <>
      {errorMesage ? errorMesage : ""}
      <Helmet>
        <title>Roles | SFM</title>
      </Helmet>
      {openModel ? (
        <CModel open={openModel} setOpen={setOpenModel} filter={"add-role"} />
      ) : (
        ""
      )}
      {openUpdateModel ? (
        <CModel
          open={openUpdateModel}
          data={selectedRow}
          permissions={permissions}
          setOpen={setOpenUpdateModel}
          filter={"update-role"}
        />
      ) : (
        ""
      )}
      {canViewRoleList && (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Stack direction="row" alignItems="center" spacing={1}>
                <HomeRounded color="inherit" />
                <Typography variant="body1" color="textPrimary">
                  / Roles
                </Typography>
              </Stack>
            </Breadcrumbs>
            {canAddRole && (
              <Stack direction="row" spacing={1}>
                <Button onClick={() => navigate("/skills-matrix")} variant="outlined" startIcon={<Iconify icon="eva:grid-outline" />}>
                  Employee Skills Matrix
                </Button>
                <Button onClick={handleOpenModel} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
                  New Role
                </Button>
              </Stack>
            )}
          </Stack>

          <Card>
            <UserListToolbar
              label={"Search roles..."}
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />

            <Scrollbar>
              <TableContainer>
                <SmartTable tableId="roles" lockedColumns={["Name"]}>
                  <UserListHead
                    // order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={roles.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const { id, name, permissions } = row;
                        const selectedUser = selected.indexOf(name) !== -1;
                        return (
                          <TableRow
                            hover
                            key={id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={selectedUser}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                            >
                              <Stack direction="row" alignItems="center">
                                {/* <Avatar alt={name} src={'R'} /> */}
                                <Typography
                                  variant="subtitle2"
                                  sx={{ padding: "0px 15px" }}
                                  noWrap
                                >
                                  {name}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">
                              {permissions ? permissions.length : 0}
                            </TableCell>
                            <TableCell
                              align="right"
                              style={{ display: "flex" }}
                            >
                              {canEditRole && (
                                <MenuItem
                                  onClick={() => {
                                    setSelectedRow(row);
                                    setOpenUpdateModel(!openUpdateModel);
                                  }}
                                >
                                  <Iconify icon={"eva:edit-fill"} />
                                </MenuItem>
                              )}

                              {canEditRole && (
                                <MenuItem onClick={() => openDuties(row)} title="Duties & Responsibilities">
                                  <Iconify icon={"eva:file-text-outline"} />
                                </MenuItem>
                              )}

                              {canDeleteRole && (
                                <MenuItem
                                  sx={{ color: "error.main" }}
                                  onClick={() => handleDelete(id)}
                                >
                                  <Iconify icon={"eva:trash-2-outline"} />
                                </MenuItem>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete
                              words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </SmartTable>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={roles.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      )}

      <Dialog open={!!dutiesRole} onClose={() => setDutiesRole(null)} fullWidth maxWidth="md">
        <DialogTitle sx={{ bgcolor: "#1D2330", color: "#fff" }}>
          Duties &amp; Responsibilities — {dutiesRole?.name}
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
            This is the position description each holder of this role must sign and date on first login.
            Per AISC 207-25 §1.14 / ISO 9001:2015 §7.2. Editing the text prompts every holder to re-sign.
          </Typography>
          <TextField
            label="Duties & Responsibilities for this position"
            value={dutiesText}
            onChange={(e) => setDutiesText(e.target.value)}
            fullWidth multiline minRows={12}
            placeholder={"Describe the position's duties, responsibilities, authorities, and reporting line..."}
          />
          <Typography variant="subtitle2" sx={{ mt: 3, mb: 1, fontWeight: 700 }}>
            Sign-off log {dutiesAcks.length ? `(${dutiesAcks.length})` : ""}
          </Typography>
          {dutiesAcks.length === 0 ? (
            <Typography variant="body2" sx={{ color: "text.disabled" }}>
              No one has signed these duties yet.
            </Typography>
          ) : (
            <Box sx={{ border: "1px solid #E3E6EA", borderRadius: 1.5, overflow: "hidden" }}>
              {dutiesAcks.map((a) => (
                <Box key={a.id} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center",
                  px: 1.5, py: 1, borderBottom: "1px solid #F0F2F5", fontSize: "0.85rem" }}>
                  <Box>
                    <strong>{a.signed_name}</strong>
                    <Typography component="span" variant="caption" sx={{ color: "text.secondary", ml: 1 }}>
                      {[a.firstName, a.lastName].filter(Boolean).join(" ")}{a.email ? ` · ${a.email}` : ""}
                    </Typography>
                  </Box>
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    v{a.duties_version} · {a.acknowledged_at ? new Date(a.acknowledged_at).toLocaleString() : ""}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDutiesRole(null)}>Cancel</Button>
          <Button variant="contained" onClick={saveDuties} disabled={dutiesSaving}
            startIcon={dutiesSaving ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{ bgcolor: "#1D2330", "&:hover": { bgcolor: "#2A3340" } }}>
            {dutiesSaving ? "Saving…" : "Save Duties"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
